import {
  ButtonGroup,
  Divider,
  Flex,
  FormControl,
  Heading,
  HStack,
  IconButton,
  SimpleGrid,
  Stack,
  Text,
  Tooltip,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Card from "../../../components/card/Card";
import CustomButton from "../../../components/Common/CustomButton";
import IsLoading from "../../../components/Common/IsLoading";
import {
  selectButtonLoading,
  selectEndDate,
  selectFormData,
  selectLoading,
  selectOrder,
  selectOrderPageNo,
  selectOrderPageSize,
  selectOrderTotalRow,
  selectStartDate,
} from "./redux/selector";
import { actions } from "./redux/slice";
import { useTranslation } from "react-i18next";
import DateFormat from "../../../components/Common/DateFormat";
import Api, { apiPath } from "../../../utils/Api";
import CustomInput from "../../../components/Common/CustomInput";
import { CommonTable } from "../../../components/CommonTable";
import { DataImportantStatusEnum, ENUM_USER_SHIPPING_STATUS, ENUM_USER_STATUS, IUserOrderData } from "../user/types";
import { createColumnHelper } from "@tanstack/react-table";
import { MdReceiptLong } from "react-icons/md";
import DateRangeInputs from "../order/DateRangeInputs";
import { DateTime } from "luxon";
import { toast } from "sonner";
import CustomSelect from "../../../components/Common/CustomInput/CustomSelect";


const Create = () => {
  const { t } = useTranslation();
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const form = useSelector(selectFormData);
  const loader = useSelector(selectLoading);
  const loading = useSelector(selectButtonLoading);
  const pageNo = useSelector(selectOrderPageNo);
  const pageSize = useSelector(selectOrderPageSize);
  const startDate = useSelector(selectStartDate);
  const endDate = useSelector(selectEndDate);
  const [selectedRow, setSelectedRow] = useState<string[]>([]);

  const orders = useSelector(selectOrder);

  const total = useSelector(selectOrderTotalRow);

  useEffect(() => {
    console.log("Selected Rows: ", selectedRow);

    return () => {};
  }, [selectedRow]);

  React.useEffect(() => {
    if (params.id) {
      dispatch(actions.doGetById(params?.id));
    }
    return () => {};
  }, [params.id]);

  const handleCancel = () => {
    dispatch(actions.clearFrom());
    navigate(-1);
  };

  const handleFieldChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = evt.target;
    dispatch(actions.updateFormValue({ key: name, value: value }));
  };
  React.useEffect(() => {
    if (params.id) {
      dispatch(actions.doGetOrderList(params.id));
    }
    return () => {};
  }, [pageNo, pageSize, params.id]);
  const FieldRow = ({ label, value }: { label: string; value: string }) => (
    <Flex>
      <Text fontWeight="semiBold" minW="150px">
        {label}:
      </Text>
      <Text fontWeight="light">{value}</Text>
    </Flex>
  );
  const handleDownload = (id: string) => {
    window.open(`${apiPath()}user/order/invoice/${id}`);
  };
  const handleMultipleDownload = () => {
    Api.post(
      "user/order/download/multiple/invoice",
      {
        invoiceIds: selectedRow,
      },
      {
        responseType: "blob",
      }
    )
      .then((response: any) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        console.log(response);
        var link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `invoices.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleSubmit = () => {
    if (form?._id) {
      dispatch(
        actions.doUpdate({
          callback() {
            dispatch(actions.clearFrom());
            navigate(-1);
          },
        })
      );
    }
  };
  const columnHelper = createColumnHelper<IUserOrderData>();
  const columns = [
    columnHelper.accessor("_id", {
      id: "_id",
      header: `${t("common.list.sNo")}`,
      cell: (info) => {
        return (
          <>
            {pageNo === 1 ? (
              <>{info.row.index + 1}</>
            ) : (
              <>{`${(pageNo - 1) * pageSize + info.row.index + 1}`}</>
            )}
          </>
        );
      },
    }),
    columnHelper.accessor("orderId", {
      id: "orderId",
      header: `${t("common.list.orderId")}`,
      cell: (info) => <Text>{info.getValue() || "NA"}</Text>,
    }),
    columnHelper.accessor("totalPrice", {
      id: "totalPrice",
      header: `${t("common.list.price")}`,
      cell: (info) => <Text>¥{info.getValue() || "NA"}</Text>,
    }),

    columnHelper.accessor("createdAt", {
      id: "createdAt",
      header: `${t("common.list.createdAt")}`,
      cell: (info) => <Text>{DateFormat(info.getValue()) || "NA"}</Text>,
    }),
    columnHelper.accessor("_id", {
      id: "_id",
      header: `${t("common.list.actions")}`,
      cell: (info) => {
        return (
          <HStack>
            <Tooltip label={t("common.list.invoice")}>
              <IconButton
                aria-label="Export CSV"
                icon={<MdReceiptLong size={20} />}
                onClick={() => {
                  handleDownload(info.row.original.invoiceId);
                }}
                colorScheme="brand"
                variant="solid"
                size="md"
              />
            </Tooltip>
          </HStack>
        );
      },
    }),
  ];
  const handleDate = () => {
    if (startDate === null) {
      toast.error(t("order.list.enterStartDate"));
      return;
    }
    if (endDate === null) {
      toast.error(t("order.list.enterEndDate"));
      return;
    }
    const start =
      typeof startDate === "string" ? DateTime.fromISO(startDate) : startDate;
    const end =
      typeof endDate === "string" ? DateTime.fromISO(endDate) : endDate;

    if (end < start) {
      toast.error(t("order.list.validEndDate"));
      return;
    }
    dispatch(actions.doGetOrderList(params.id || ""));
  };
  const onClearDate = () => {
    dispatch(actions.setEndDate(null));
    dispatch(actions.setStartDate(null));
    dispatch(actions.doGetOrderList(params.id || ""));
  };

  const handleEndDate = (date: DateTime | null) => {
    //@ts-ignore
    dispatch(actions.setEndDate(date?.toFormat("yyyy-MM-dd")));
  };
  const handleStartDate = (date: DateTime | null) => {
    //@ts-ignore
    dispatch(actions.setStartDate(date?.toFormat("yyyy-MM-dd")));
  };
  useEffect(() => {
    console.log("Form Data: ", form);
    
  
    return () => {
      
    }
  }, [form])
  
  return (
    <Flex pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <Card>
        {loader ? (
          <IsLoading />
        ) : (
          <FormControl>
            <Stack spacing={4}>
              {/* Name */}
              <FieldRow
                label={`${t("register.fullName")}`}
                value={` ${form?.lastName} ${form?.firstName}`}
              />

              {/* Japanese Name */}
              <FieldRow
                label={`${t("register.japaneseName")}`}
                value={` ${form?.japaneseLastName} ${form?.japaneseFirstName}`}
              />

              {/* Contact Info */}
              <FieldRow label={`${t("register.email")}`} value={form?.email} />
              <FieldRow
                label={`${t("register.phone")}`}
                value={form?.mobileNumber}
              />
              {/* Address Section */}
              <Divider my={2} />
              <Heading size="sm">{`${t("register.address")}`}</Heading>

              <FieldRow
                label={`${t("register.streetAddress")}`}
                value={form?.streetAddress}
              />
              <FieldRow
                label={`${t("register.postalCode")}`}
                value={form?.postCode}
              />

              <FieldRow
                label={`${t("register.prefecture")}`}
                value={form?.prefectures}
              />

              {/* Company */}
              <Divider my={2} />
              <FieldRow
                label={`${t("register.company")}`}
                value={form?.companyName}
              />
              <FieldRow
                label={`${t("common.form.importantStatus")}`}
                value={form?.importantStatus}
              />
              <FormControl>
                <SimpleGrid columns={[1, 1, 2, 3]} spacingX={5}>
                  <CustomInput
                    name={"customerId"}
                    value={form?.customerId || ""}
                    handleChange={handleFieldChange}
                    placeholder={t("common.form.customerId")}
                    title={t("common.form.customerId")}
                  />
                  <CustomSelect
                    name={"shippingFreeStatus"}
                    value={form?.shippingFreeStatus}
                    handleChange={handleFieldChange}
                    title={`${t("common.form.shippingFreeStatus")}`}
                    data={FreeShippingStatusData}
                  />
                  <CustomSelect
                    name={"status"}
                    value={form?.status}
                    handleChange={handleFieldChange}
                    title={`${t("common.form.status")}`}
                    data={StatusData}
                  />
                  <CustomSelect
                    name={"importantStatus"}
                    value={form?.importantStatus}
                    handleChange={handleFieldChange}
                    title={`${t("common.form.importantStatus")}`}
                    data={ImportantStatusData}
                  />
                </SimpleGrid>
              </FormControl>
            </Stack>
            <SimpleGrid columns={1} spacing={10}>
              <Flex flexDirection="column">
                <ButtonGroup justifyContent={"flex-end"} mt={8}>
                  <CustomButton
                    handleClick={handleCancel}
                    title={t("common.button.cancel")}
                    variant="light"
                    sx={{ marginRight: "20px" }}
                  />
                  <CustomButton
                    handleClick={handleSubmit}
                    title={t("common.button.save")}
                    loading={loading}
                    disabled={!form?.customerId}
                    sx={{ marginLeft: "20px" }}
                  />
                </ButtonGroup>
              </Flex>
            </SimpleGrid>
            <Stack>
              <CommonTable<IUserOrderData>
                columns={columns}
                data={orders}
                totalCount={total}
                pageNo={pageNo}
                pageSize={pageSize}
                search={""}
                loading={false}
                onSearch={(v) => dispatch(actions.setSearch(v))}
                onPageChange={(p) => dispatch(actions.setOrderPageNo(p))}
                onPageSizeChange={(s) => dispatch(actions.setOrderPageSize(s))}
                onSortChange={(id, desc) => {
                  dispatch(actions.setOrderBy(id));
                  dispatch(actions.setOrderDir(desc ? "desc" : "asc"));
                }}
                hideAddButton
                showSearch
                showSelection
                onRowSelectChange={(rows) => {
                  setSelectedRow(
                    rows.map((r) => r.invoiceId).filter((r) => r !== undefined)
                  );
                }}
                filters={
                  <HStack>
                    <DateRangeInputs
                      startDate={startDate ?? null}
                      endDate={endDate ?? null}
                      handleStartDate={handleStartDate ?? (() => {})}
                      handleEndDate={handleEndDate ?? (() => {})}
                      onSearch={handleDate ?? (() => {})}
                      onClear={onClearDate ?? (() => {})}
                    />
                    <CustomButton
                      handleClick={handleMultipleDownload}
                      title={t("common.button.downloadInvoice")}
                      loading={false}
                      disabled={selectedRow.length === 0}
                      sx={{ marginLeft: "20px", marginBottom: 0 }}
                    />
                  </HStack>
                }
              />
            </Stack>
          </FormControl>
        )}
      </Card>
    </Flex>
  );
};

export default Create;
export const FreeShippingStatusData = [
  { _id: ENUM_USER_SHIPPING_STATUS.YES, value: "common.text.yes" },
  { _id: ENUM_USER_SHIPPING_STATUS.NO, value: "common.text.no" },
];

export const ImportantStatusData = [
  { _id: DataImportantStatusEnum.IMPORTANT, value: "common.text.important" },
  { _id: DataImportantStatusEnum.NOT_IMPORTANT, value: "common.text.notImportant" },
];
export const StatusData = [
  { _id: ENUM_USER_STATUS.ACTIVE, value: "common.text.active" },
  { _id: ENUM_USER_STATUS.INACTIVE, value: "common.text.inActive" },
];
